import type from './ProductHistory.type';

const initialState = {
  historyListRecords: 0,
  historyList: [],
  userList: {},
};

const productHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.GET_HISTORY_LIST:
      return {
        ...state,
        historyList: [...state.historyList, ...(action.payload?.documents || [])],
        historyListRecords: action.payload?.totalRecords,
        userList: { ...state.userList, ...action.payload?.users },
      };
    case type.CLEAR_REDUCER:
      return {
        ...state,
        historyListRecords: 0,
        historyList: [],
        userList: [],
      };
    default:
      return state;
  }
};

export default productHistoryReducer;
